/** Pathname part of a nav `to` that may include a query string. */
export function navItemPathname(path) {
    const q = path.indexOf('?');
    return q === -1 ? path : path.slice(0, q);
}
function navItemQuery(path) {
    const q = path.indexOf('?');
    return q === -1 ? '' : path.slice(q + 1);
}
function viewFromSearch(search) {
    const raw = search.startsWith('?') ? search.slice(1) : search;
    return new URLSearchParams(raw).get('view');
}
/**
 * Active state for sidebar / bottom nav.
 * «Воронки» and «Договор с АН» share `/engagements` and split by `view`.
 */
export function isNavItemActive(item, pathname, search = '') {
    const base = navItemPathname(item.path);
    if (base === '/')
        return pathname === '/';
    if (base === '/engagements') {
        if (pathname !== '/engagements')
            return false;
        const itemView = viewFromSearch(navItemQuery(item.path));
        const currentView = viewFromSearch(search);
        if (itemView === 'contract')
            return currentView === 'contract';
        return currentView !== 'contract';
    }
    if (base === '/agents') {
        return pathname === '/agents' || pathname.startsWith('/agents/');
    }
    return pathname === base || pathname.startsWith(`${base}/`);
}
/** Compact «Ещё» is active when the current route belongs to BOTTOM_NAV_MORE. */
export function isBottomNavMoreRoute(pathname, search, morePaths) {
    if (pathname.startsWith('/agents/'))
        return true;
    if (pathname === '/engagements' &&
        viewFromSearch(search) === 'contract' &&
        morePaths.includes('/engagements?view=contract')) {
        return true;
    }
    return morePaths.some((path) => {
        const base = navItemPathname(path);
        if (path.includes('?'))
            return false;
        return pathname === base || pathname.startsWith(`${base}/`);
    });
}
